import React, { useState } from 'react';
import classNames from 'classnames';

const NavigationContext = React.createContext(false);

const MainNavigation = props => {
  const { children } = props;
  const [activeState, setActiveState] = useState(false);

  const changeState = () => {
    setActiveState(!activeState)
    console.log(`active state: ${!activeState}`)
  };

  const mainNavigationClasses = classNames({
    'navigation-main': true,
    active: activeState,
  });

  return (
    <NavigationContext.Provider value={activeState}>
      <nav
        className={mainNavigationClasses}
        onClick={changeState}
      >
        {children}
      </nav>
    </NavigationContext.Provider>
  );
};

export default MainNavigation;